<template>
    <div>
        <el-upload
            class="upload-demo"
            :action="uploadUrl"
            ref="upload"
            :before-upload="fnBeforeUpload"
            :on-success="fnUploadSuccess"
            :on-exceed="fnUploadExceed"
            :headers="uploadHeaders"
            :http-request="fnUploadRequest"
            :name="txtName"
            :on-remove="handleRemove"
            :limit="files"
            :disabled="disabled"
            :file-list="fileList1"
            multiple>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">* 建议上传文件大小不超过1G,最多上传5个</div>
            <div slot="tip" class="el-upload__tip">* 上传文件类型限制：jpg,gif,png,jpeg,doc,docx,xls,xlsx,ppt,pptx,txt,pdf,zip,rar,7z</div>
        </el-upload>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { Loading } from 'element-ui';
    const OSS = require('ali-oss')
    export default {
        name: 'ossUpload',
        data () {
            return {
                userInfo:{},
                region: 'oss-cn-beijing', //'cn-beijing',//
                bucket: 'new-zhuanzhen', //文件夹名
                client: {},
                uploadUrl: '1111',
                txtName:'',
                uploadFileLength: 0,
                uploadFileSuccess: 0,
                uploadFileNames: [],
                uploadFileName: [],
                fileList1: [],
                fileList: [],
                extension:'',//文件扩展名
                files: 5,
                uploadHeaders: {
                    authorization: ''
                },
                disabled: false
            }
        },
        props: {
            target: {
                type: String,
                default: 'zhuanzhen'
            },
            fileName:String,
            flag:String
        },
        mounted () {
            this.init()
        },
        methods: {
            init(){
                this.userInfo=this.$common.getStorage('userInfo');
                if(this.flag=='true'||this.flag=='other'){
                    this.files=1
                }
                else if(this.flag=='false'){
                    this.files=5
                }
                //获得oss临时账号
                this.$ajax.post(this.$domain.getReadAndWriteOSS,{})
                .then( res => {
                    console.log(res.data)
                    if (!(res.data.data)) {
                        throw new Error('获取OSS参数失败')
                    }
                    this.client = new OSS({
                        region: this.region,
                        accessKeyId: res.data.data.ossAccessKeyId,
                        accessKeySecret: res.data.data.ossAccessKeySecret,
                        stsToken: res.data.data.ossSecurityToken,
                        bucket: this.bucket
                    })
                })
            },
            /**
             * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
             * @author   shanshuizinong
             * @param    {object}   option [上传选项]
             * @return   {null}   [没有返回]
             */
            fnUploadRequest (option) {
                try {
                    let vm = this

                    let file = option.file
                    let length = file.name.lastIndexOf('.')
                    let typeName = file.name.slice(length+1)
                    let hosiCode = this.userInfo.hospCode
                    let date = vm.$common.getAllDate()
                    let time = vm.$common.getTime()
                    
                    if(this.flag=='true'){
                        var nameStr=this.fileName+'.'+typeName;
                        console.log(nameStr)
                        console.log(file.name);
                        if(typeName!=='7z'&&typeName!=='zip'&&typeName!='rar'){
                            this.$message.error('文件格式不对，禁止上传！')
                            this.handleRemove(file,this.fileList1);
                            this.handleRemove(file,this.fileList);
                            this.clear();
                            return;
                        }
                        if(nameStr!=file.name){
                            this.$message.error('文件名称有误！禁止上传')
                            this.handleRemove(file,this.fileList1)
                            this.handleRemove(file,this.fileList)
                            this.clear();
                            return;
                        }
                    }
                    else if(this.flag=='other'){
                        if(typeName!=='pdf'){
                            this.$message.error('文件格式不对，仅能上传PDF文件！')
                            this.handleRemove(file,this.fileList);
                            this.handleRemove(file,this.fileList1)
                            this.clear();
                            return;
                        }
                    }
                    else{
                        let arr=['jpg','gif','png','jpeg','doc','docx','xls','xlsx','ppt','pptx','txt','pdf','zip','rar','7z'];
                        if(arr.indexOf(typeName)<0){
                            this.$message.error('禁止上传此格式文件！');
                            this.handleRemove(file,this.fileList);
                            this.handleRemove(file,this.fileList1)
                            this.clear();
                            return;
                        }
                    }
                    let fileNames = `${hosiCode}/${this.target}/${typeName}/${date}/${file.name}`
                    // 分片上传文件
                    let loadingInstance=null;
                    console.log(hosiCode)
                    this.client.multipartUpload(fileNames, file, {
                        progress: async function (p) {
                            loadingInstance = Loading.service({
                                fullscreen: true,
                                text:'大文件上传中',
                                background:"rgba(0, 0, 0, 0.4)" 
                            });
                            let e = {}
                            e.percent = p * 100
                            option.onProgress(e)
                        }
                    }).then(ret=> {
                        loadingInstance.close();
                        console.log(ret)
                        if (ret.res.statusCode === 200) {
                            option.onSuccess(ret);
                            vm.fileList.push({
                                attachName:file.name,
                                attachExtension:typeName,
                                attachUrl:ret.name
                            })
                            console.log(vm.fileList)
                            return ret
                        } else {
                            vm.disabled = false
                            option.onError('上传失败')
                        }
                    })
                    
                } catch (error) {
                    console.log(error);
                    this.disabled = false
                    option.onError('上传失败')
                    this.$error(error.message)
                }
            },
            /**
             * @description [fnUploadSuccess 文件上传成功的函数]
             * @author   shanshuizinong
             * @return   {null}  [没有返回]
             */
            fnUploadSuccess (response, file, fileList) {
                // if(this.fileName){
                //     file.name= `${this.fileName}.${this.extension}`;
                // }
                this.$emit('fileList', this.fileList) 
            // TODO
            },
            //上传前的函数
            fnBeforeUpload(file,fileList) {
                if(this.flag=="true"&&this.fileName==''){
                    this.$message.error('未生成文件名称！不能上传文件')
                    abort(file);
                }
                
            },
            fnUploadExceed() {
                this.$message.error('最多只能上传5个附件!')
            },
            handleRemove(file,fileList){
                this.$common.removeArr(file,fileList);
                if(this.flag=='true'||this.flag=='other'){
                    this.fileList=[];
                    this.$emit('toParent',file);
                }
                else{
                    let obj={
                        attachName:file.name,
                        attachExtension:file.name.split('.')[1],
                        attachUrl:file.response.name
                    }
                    this.$store.state.examFile.push(obj);
                }
            },
            clear(){
                this.uploadUrl=''
                this.txtName=''
                this.uploadFileLength=0
                this.uploadFileSuccess=0
                this.uploadFileNames=[]
                this.uploadFileName=[]
                this.fileList=[]
                this.fileList1=[]
                this.extension=''//文件扩展名
                this.uploadHeaders={
                    authorization: ''
                }
                this.disabled=false
            }
        }
    }
</script>
<style>
.el-upload-list__item{
    width:90%;
    font-size: 16px;
    margin:2px auto;
    text-align: left;
    border:1px solid #ccc;
    padding:2px;
}
.el-upload-list__item{
    padding:10px!important;
    height:50px!important;
}
.el-upload-list__item-name{
    line-height: 30px!important;
}
.el-upload-list__item .el-progress{
    top:30px!important;
    width:98%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Upload/index.vue